// 動画の配信元の URL を、埋め込みのプレーヤーの URL にそろえる（動画のサイトマップと VideoObject で共通、仕様 0023）

const YOUTUBE_ID = /^[A-Za-z0-9_-]{11}$/
const VIMEO_ID = /^\d+$/
const VIMEO_UNLISTED_HASH = /^[A-Fa-f0-9]{10}$/

const youtubeIdFromUrl = (parsed) => {
  const hostname = parsed.hostname.toLowerCase()
  const segments = parsed.pathname.split("/").filter(Boolean)

  if (hostname === "youtu.be") {
    return segments.length === 1 ? segments[0] : null
  }

  if (
    hostname !== "youtube.com" &&
    hostname !== "www.youtube.com" &&
    hostname !== "m.youtube.com"
  ) {
    return null
  }

  if (parsed.pathname === "/watch") return parsed.searchParams.get("v")
  if (
    segments.length === 2 &&
    ["embed", "shorts", "live"].indexOf(segments[0]) !== -1
  ) {
    return segments[1]
  }
  return null
}

const vimeoPlayerFromUrl = (parsed) => {
  const hostname = parsed.hostname.toLowerCase()
  const segments = parsed.pathname.split("/").filter(Boolean)

  if (hostname === "player.vimeo.com") {
    if (segments.length !== 2 || segments[0] !== "video") return null
    const hashes = parsed.searchParams.getAll("h")
    if (hashes.length > 1) return null
    const unlistedHash = hashes.length === 1 ? hashes[0] : null
    if (unlistedHash && !VIMEO_UNLISTED_HASH.test(unlistedHash)) return null
    return { id: segments[1], unlistedHash }
  }

  if (hostname !== "vimeo.com" && hostname !== "www.vimeo.com") return null
  if (segments.length === 1) return { id: segments[0], unlistedHash: null }
  if (
    segments.length === 2 &&
    VIMEO_ID.test(segments[0]) &&
    VIMEO_UNLISTED_HASH.test(segments[1])
  ) {
    return { id: segments[0], unlistedHash: segments[1] }
  }
  return null
}

const normalizePlayerUrl = (value) => {
  if (typeof value !== "string") return null

  try {
    const parsed = new URL(value)
    if (
      (parsed.protocol !== "http:" && parsed.protocol !== "https:") ||
      parsed.username !== "" ||
      parsed.password !== ""
    ) {
      return null
    }

    const youtubeId = youtubeIdFromUrl(parsed)
    if (youtubeId && YOUTUBE_ID.test(youtubeId)) {
      return `https://www.youtube.com/embed/${youtubeId}`
    }

    const vimeoPlayer = vimeoPlayerFromUrl(parsed)
    if (vimeoPlayer && VIMEO_ID.test(vimeoPlayer.id)) {
      const hash = vimeoPlayer.unlistedHash
        ? `?h=${vimeoPlayer.unlistedHash}`
        : ""
      return `https://player.vimeo.com/video/${vimeoPlayer.id}${hash}`
    }
    return null
  } catch (error) {
    return null
  }
}

module.exports = {
  normalizePlayerUrl,
}
